import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@app/services';

export const notLoggedInGuardGuard: CanActivateFn = (route, state) =>
{
    const router = inject(Router);
    const authService = inject(AuthService);

    if (!authService.isLoggedIn())
    {
        return true;
    }

    return router.createUrlTree(['tabs', 'home']);
};
